export default __webpack_public_path__ + "static/media/logo-light.9f7b80bb.svg";